import { WebsiteKeywordsPage2Filters } from "./filters/WebsiteKeywordsPage2Filters";
import { NotificationBanner } from "./notifications/NotificationBanner";
import { WebsiteKeywordsPage2Table } from "./table/WebsiteKeywordsPage2Table";
import type { IColumnsConfigArguments } from "./table/WebsiteKeywordsPage2TableColumns";
import { WebsiteKeywordsPage2AboveTableMetrics } from "./WebsiteKeywordsPage2AboveTableMetrics";
import { WebsiteKeywordsPage2ContextProvider } from "./WebsiteKeywordsPage2Context";

interface IWebsiteKeywordsPage2Props {
    withAddToDashboard?: boolean;
    getColumnsFunction?: (args: IColumnsConfigArguments) => any;
    keywordGroupState?: string;
}

export const WebsiteKeywordsPage2 = ({
    withAddToDashboard = true,
    getColumnsFunction,
    keywordGroupState,
}: IWebsiteKeywordsPage2Props) => {
    return (
        <WebsiteKeywordsPage2ContextProvider>
            <NotificationBanner />
            <WebsiteKeywordsPage2Filters />
            <WebsiteKeywordsPage2AboveTableMetrics />
            <WebsiteKeywordsPage2Table
                withAddToDashboard={withAddToDashboard}
                getColumnsFunction={getColumnsFunction}
                keywordGroupState={keywordGroupState}
            />
        </WebsiteKeywordsPage2ContextProvider>
    );
};
